import './Info.less';
export { default as infoText } from './components/text';
export { default as Info } from './Info';
export { default } from './Info';